import { motion } from "motion/react";
import { useSectionParallax } from "../../hooks/useSectionParallax";

const IVIZ = { name: "iViz", textCls: "text-[#1E4FD8] dark:text-[#4A90D9]", borderCls: "border-[#1E4FD8] dark:border-[#4A90D9]" };
const FORESIGHT = { name: "Foresight", textCls: "text-[#5B21B6] dark:text-[#B9A5FF]", borderCls: "border-[#5B21B6] dark:border-[#7C4DFF]" };

const AUDIENCES = [
  { title: "If you write code", body: "Python and R on cloud kernels with popular libraries installed, plus an AI assistant that writes and runs code.", product: IVIZ },
  { title: "If you don't", body: "Statistics, models, and charts on a visual canvas, with an AI assistant that builds the analysis for you.", product: IVIZ },
  { title: "Pharmacologists & modelers", body: "Bring the models you already have and run trial designs on digital twin cohorts.", product: FORESIGHT },
  { title: "Clinical development", body: "Stress-test a trial design, and see how reliably it decides, before committing to it.", product: FORESIGHT },
];

export function HomeAudiences() {
  const { ref, bgY, fgY } = useSectionParallax();
  return (
    <section ref={ref} className="py-20 bg-[#FAFAFA] dark:bg-[#050505]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <motion.h2 style={{ y: fgY }} className="text-3xl md:text-4xl font-normal tracking-[-0.02em] text-[#0A0A0F] dark:text-white text-center max-w-2xl mx-auto mb-12">
          Built for how you work.
        </motion.h2>
        <motion.div style={{ y: bgY }} className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {AUDIENCES.map(({ title, body, product }) => (
            <div key={title} className={`border-t-2 pt-5 ${product.borderCls}`}>
              <p className="text-xs font-bold uppercase tracking-widest text-[#0A0A0F] dark:text-white">{title}</p>
              <p className="mt-3 text-sm leading-[1.7] text-[#5C5C66] dark:text-[#9A9A9A]">{body}</p>
              <p className={`mt-4 text-xs font-semibold uppercase tracking-widest ${product.textCls}`}>{product.name}</p>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
